import { ColumnHeaderMultiSelectFilter } from "components/ReusableHeaderFilter/ColumnHeaderMultiSelectFilter";
import { useUpdateQuery } from "hooks/useQuery";

export const MultiselectHeader = ({
  options,
  selected,
  title,
  filterKey,
}: {
  options: { label: string; value: string }[];
  selected: string | null;
  title: string;
  filterKey: string;
}) => {
  const { update } = useUpdateQuery();

  const updateFilter = (filterName: string, value: string | null) => {
    update({ query: filterName, value });
  };

  return (
    <div className="t-flex t-items-center t-justify-between t-w-full">
      <div>{title}</div>
      <ColumnHeaderMultiSelectFilter
        filterName={filterKey}
        options={options}
        selected={selected}
        updateFilter={updateFilter}
      />
    </div>
  );
};
